<!--
 * @Author: luxiangqiang
 * @Date: 2023-04-26 14:59:01
 * @LastEditors: luxiangqiang
 * @LastEditTime: 2023-05-09 10:53:37
-->
<template>
  <div class="sidebar-recommendations">
    <div class="tools">
      <h3>雇佣工具</h3>
      <div class="tool-item" v-for="item of tools" :key="item.title">
        <img :src="item.iconUrl" :alt="item.title" />
        <div class="item-content">
          <span>{{ item.title }}</span>
          <span>{{ item.desc }}</span>
        </div>
        <nuxt-link class="item-look" :to="getUrl(item)"> 查看 </nuxt-link>
      </div>
    </div>
    <div class="recommend"></div>
  </div>
</template>

<script setup lang="ts">
import { salaryToolJobList } from '~~/common/global';
const props = defineProps<{
  countryCode?: string;
  countryName?: string;
}>();

const tools = [
  {
    title: '全球雇佣指南',
    desc: '查看150+国家雇佣资料',
    iconUrl: 'https://video.reta-inc.com/image/default/2FC68006C25046239EB3A11F1CB178C0-6-2.png',
    path: '/resource/global',
  },
  {
    title: '雇佣成本计算器',
    desc: '估算企业用工总成本',
    iconUrl: 'https://video.reta-inc.com/image/default/FD889D56696242A4A0FE65997FA68404-6-2.png',
    path: '/resource/cost-calculator',
    withQueryPath: `/resource/cost-calculator?amount=50000&countryCode=${props.countryCode}`,
  },
  {
    title: '全球劳动法',
    desc: '查看各国劳动法政策',
    iconUrl: 'https://video.reta-inc.com/image/default/68F2C54D61984A3D8DC97B6995106C4D-6-2.png',
    path: '/resource/global/global/labor-employment-regulations',
    withParamPath: `/resource/global/${props.countryName}/labor-employment-regulations`,
  },
  {
    title: '全球税收政策',
    desc: '查看各国用工税收政策',
    iconUrl: 'https://video.reta-inc.com/image/default/415911DBF3F14A90976B387FCA311264-6-2.png',
    path: '/resource/global/global/corporate-tax',
    withParamPath: `/resource/global/${props.countryName}/corporate-tax`,
  },
  {
    title: '全球政府机构',
    desc: '了解150+国家政府机构信息',
    iconUrl: 'https://video.reta-inc.com/image/default/F4EAA87E64B34934BA33A1ACA9342760-6-2.png',
    path: '/resource/global/global/government-departments-relevant-institutions',
    withParamPath: `/resource/global/${props.countryName}/government-departments-relevant-institutions`,
  },
  {
    title: '全球银行保险机构',
    desc: '了解150+国家银保机构信息',
    iconUrl: 'https://video.reta-inc.com/image/default/EBAD19A3A5914FF1A030B98AA272C1C3-6-2.png',
    path: '/resource/global/global/banks-insurance-companies',
    withParamPath: `/resource/global/${props.countryName}/banks-insurance-companies`,
  },
  {
    title: '全球薪酬洞察',
    desc: '了解全球市场员工薪酬信息',
    iconUrl: 'https://video.reta-inc.com/image/default/F07A75EC8B844A97A8B57C4D692AE827-6-2.png',
    path: '/resource/compensation-insight-tool',
    withQueryPath: `/resource/compensation-insight-tool-detail?countryCode=${props.countryCode}&jobTitle=${salaryToolJobList[0].value}`,
  },
  {
    title: '员工工资计算器',
    desc: '估算员工税后实得工资',
    iconUrl: 'https://video.reta-inc.com/image/default/6919A716887448C7ACFBED8B0489AA73-6-2.png',
    path: '/resource/wage-calculator',
    withQueryPath: `/resource/wage-calculator?countryCode=${props.countryCode}&amount=50000`,
  },
];

function getUrl(item: (typeof tools)[0]) {
  const { withParamPath, withQueryPath, path } = item;
  if (props.countryCode && withQueryPath) {
    return withQueryPath;
  }
  if (props.countryName && withParamPath) {
    return withParamPath;
  }
  return path;
}
</script>

<style scoped lang="less">
.sidebar-recommendations {
  box-sizing: border-box;

  .tools {
    padding: 0 24px 24px;
    box-sizing: border-box;
    background: linear-gradient(180deg, rgba(182, 251, 255, 0.2) 0%, rgba(188, 210, 255, 0) 22.46%), #ffffff;
    border: 1px solid #e8f0ff;
    border-radius: 8px;

    h3 {
      font-weight: 500;
      font-size: 20px;
      line-height: 26px;
      letter-spacing: 0.01em;
      color: #1d2129;
    }

    .tool-item {
      display: flex;
      align-items: center;
      margin-bottom: 25px;

      img {
        width: 42px;
        height: 42px;
      }

      .item-content {
        display: flex;
        flex-direction: column;
        margin-left: 12px;

        & > span:first-child {
          font-weight: 500;
          font-size: 16px;
          line-height: 22px;
          color: #1d2129;
        }

        & > span:last-child {
          margin-top: 2px;
          font-size: 12px;
          line-height: 17px;
          color: #4e5969;
          width: 150px;
        }
      }

      .item-look {
        font-size: 14px;
        line-height: 20px;
        color: #165dff;
        padding: 4px 10px;
        cursor: pointer;
        margin-left: 24px;
        margin-right: 0;
        border: 1px solid #165dff;
        border-radius: 4px;
        text-decoration: none;

        &:hover {
          border: 1px solid #4080ff;
          background-color: #4080ff;
          color: #fff;
        }
      }
    }
  }
}
</style>
